var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgvAboutUsCardFour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 124,
    viewBox: "0 0 111 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6094 41.18C30.483 22.3293 49.0947 9.08203 70.8004 9.08203C75.1328 9.08203 79.342 9.60979 83.3671 10.6045M23.195 82.7387C31.3786 100.87 49.6159 113.489 70.8004 113.489C74.8593 113.489 78.8099 113.025 82.6024 112.149M116.983 36.9245C120.827 44.197 123.004 52.487 123.004 61.2853C123.004 70.4385 120.648 79.0415 116.51 86.5211",
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9566 92.0346L61.5032 81.6654L40.0498 71.2963M82.2415 31.4287L61.5032 41.6191L40.0498 51.9882",
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0961 21.9534C80.0961 33.8018 89.7011 43.4068 101.55 43.4068C113.398 43.4068 123.003 33.8018 123.003 21.9534C123.003 10.105 113.398 0.5 101.55 0.499999C89.7011 0.499999 80.0961 10.105 80.0961 21.9534Z",
    fill: "url(#paint0_linear_79_847)",
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0961 102.046C80.0961 113.895 89.7011 123.5 101.55 123.5C113.398 123.5 123.003 113.895 123.003 102.046C123.003 90.1978 113.398 80.5928 101.55 80.5928C89.7011 80.5928 80.0961 90.1978 80.0961 102.046Z",
    fill: "url(#paint1_linear_79_847)",
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4558 82.9537C9.88354 82.9537 0.502383 73.5725 0.502383 62.0003C0.502384 50.428 9.88354 41.0469 21.4558 41.0469C33.028 41.0469 42.4092 50.428 42.4092 62.0003C42.4092 73.5725 33.028 82.9537 21.4558 82.9537Z",
    fill: "url(#paint2_linear_79_847)",
    fillOpacity: 0.5,
    stroke: "#AAECD8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_847",
    x1: 123.003,
    y1: 0.5,
    x2: 92.6554,
    y2: 50.9601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_847",
    x1: 123.003,
    y1: 80.5928,
    x2: 92.6554,
    y2: 131.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_847",
    x1: 40.7638,
    y1: 62.0003,
    x2: 0.00238468,
    y2: 62.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgvAboutUsCardFour);
export default __webpack_public_path__ + "static/media/BGVAboutUsCardFour.473310b07d57fb2e91cfe924132fcfb7.svg";
export { ForwardRef as ReactComponent };